<template>
  <div class="adm-form">
    <div class="adm-form-head">
      <div>
        <span class="adm-form-kicker"><tkd-icon name="move"/> Перенести категорію</span>
        <h4 class="adm-form-title">{{ formAddCategory.name || 'Категорія' }}</h4>
      </div>
      <button type="button" class="adm-form-close" @click="saveCategoryClose()" title="Закрити" aria-label="Закрити"><tkd-icon name="close"/></button>
    </div>

    <div class="adm-form-body">
      <section class="adm-section">
        <h5 class="adm-section-title"><tkd-icon name="section"/> Відділення</h5>
        <div class="section-options" role="radiogroup" aria-label="Відділення">
          <button type="button" role="radio" class="section-option"
                  v-for="section in sections" :key="section.id"
                  :aria-checked="isChosen(section) ? 'true' : 'false'"
                  :class="{ active: isChosen(section) }"
                  @click="formAddCategory.section = section">
            <span class="section-option-num">№ {{ section.start_number || '—' }}</span>
            <span class="section-option-name">{{ section.name }}</span>
          </button>
          <button type="button" role="radio" class="section-option muted"
                  :aria-checked="isChosen(null) ? 'true' : 'false'"
                  :class="{ active: isChosen(null) }"
                  @click="formAddCategory.section = {id: 0, name: 'Без відділення'}">
            <span class="section-option-name">Без відділення</span>
          </button>
        </div>
        <p class="section-empty" v-if="!sections.length">Ще немає відділень — спершу створіть відділення.</p>
      </section>
    </div>

    <div class="adm-form-foot">
      <div class="adm-form-foot-actions">
        <button type="button" class="adm-btn" @click="saveCategoryClose()">Скасувати</button>
        <button type="button" class="adm-btn adm-btn-primary" @click="saveCategoryAndAdd()" :disabled="!hasChoice || isSaving">
          <tkd-icon :name="isSaving ? 'loader' : 'save'"/> {{ isSaving ? 'Збереження…' : 'Зберегти' }}
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import 'src/assets/css/tkd-theme.css';
import 'src/assets/css/tkd-admin.css';

export default {
  name: "form-category",
  props: ['formAddCategory'],

  data() {
    return {
      isSaving: false,
    }
  },

  computed: {
    tournamentOne() {
      return this.$store.getters['tournament/tournamentOne'];
    },
    sections() {
      const item = this.tournamentOne && this.tournamentOne.data && this.tournamentOne.data.item;
      return item && Array.isArray(item.sections) ? item.sections : [];
    },
    hasChoice() {
      return !!(this.formAddCategory.section && this.formAddCategory.section.id !== undefined);
    },
  },

  methods: {
    // null = «Без відділення»
    isChosen(section) {
      const current = this.formAddCategory.section;
      if (!current || current.id === undefined) {
        return false;
      }
      return section ? Number(current.id) === Number(section.id) : Number(current.id) === 0;
    },

    saveCategoryClose() {
      this.$modal.hide('category-section-form-modal');
    },
    saveCategoryAndAdd() {
      this.saveCategory(false);
    },

    saveCategoryAndClose() {
      this.saveCategory(true);
    },


    saveCategory(close) {
      // раніше падало з TypeError, якщо відділення не вибрано (section був порожній)
      if (!this.hasChoice || this.isSaving) {
        return;
      }

      var params = Object.assign({}, this.formAddCategory);

      params.sectionid = this.formAddCategory.section.id == undefined ? 0 : this.formAddCategory.section.id;
      params.tournament_id = this.tournamentOne.data.item.id;

      this.isSaving = true;

      this.$store.dispatch('tournament_section/setCategorySection', params)
        .then(() => this.$store.dispatch('tournament/fetchTournamentOneFull', {id: this.tournamentOne.data.item.id}))
        .then(() => {
          this.$notify({
            text: Number(params.sectionid) ? 'Категорію перенесено у «' + this.formAddCategory.section.name + '»' : 'Категорію прибрано з відділення',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            duration: 6000,
            speed: 1000,
            type: 'success'
          });
          this.saveCategoryClose();
        })
        .catch(error => {
          alert('Помилка');
        })
        .finally(() => {
          this.isSaving = false;
        });
    },

  }
}
</script>

<style scoped>
.section-options { display: flex; flex-direction: column; gap: 6px; margin-bottom: 12px; }

.section-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 44px;
  margin: 0;
  padding: 8px 12px;
  border: 1.5px solid var(--tkd-border);
  border-radius: var(--tkd-radius);
  background: var(--tkd-surface);
  font-size: 15px;
  font-weight: 600;
  text-align: left;
  color: var(--tkd-text);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}

.section-option:hover { border-color: var(--tkd-muted); background: var(--tkd-bg); }
.section-option:focus-visible { outline: none; box-shadow: var(--adm-focus); }
.section-option.active { border-color: var(--tkd-navy); background: var(--tkd-navy); color: #fff; }
.section-option.muted { color: var(--tkd-muted); }
.section-option.muted.active { color: #fff; }

.section-option-num {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 999px;
  background: var(--tkd-bg);
  font-size: 12px;
  color: var(--tkd-muted);
}

.section-option.active .section-option-num { background: rgba(255, 255, 255, 0.15); color: #fff; }
.section-option-name { min-width: 0; overflow-wrap: anywhere; }

.section-empty { margin: 0 0 12px; font-size: 14px; color: var(--tkd-muted); }

@media (prefers-reduced-motion: reduce) {
  .section-option { transition: none; }
}
</style>
